import { Box, Checkbox, FormParagraph, TextInput } from '@ksyos/design-system';
import { translateKey } from '../../../../translate';

interface ICheckedEmailProps {
    email: string | null | undefined;
    error?: string;
    isChecked: boolean;
    onBlur?: () => Promise<void>;
    onChange: (checked: boolean, email: string | null | undefined) => Promise<void>;
    readOnly?: boolean;
}

export function CheckedEmail(props: ICheckedEmailProps) {
    return (
        <Box
            alignItems="flex-start"
            display="flex"
            gap={3}
        >
            <Checkbox
                checked={props.isChecked}
                onChange={async (e) => await props.onChange(e.target.checked, e.target.checked ? props.email : null)}
                sx={{ mt: props.readOnly ? 1 : 2, mb: 1 }}
            />

            {props.readOnly ? (
                <FormParagraph>{props.email ?? ''}</FormParagraph>
            ) : (
                <Box flexGrow="1">
                    <TextInput
                        error={props.error}
                        onBlur={props.onBlur}
                        onChange={async (e) => await handleEmailChange(e.target.value)}
                        placeholder={translateKey('common.email')}
                        value={props.email ?? ''}
                    />
                </Box>
            )}
        </Box>
    );

    async function handleEmailChange(value: string) {
        const trimmedValue = value.trim();
        const hasValue = Boolean(trimmedValue);
        await props.onChange(hasValue, hasValue ? trimmedValue : null);
    }
}
